import React from 'react';
import { Container } from 'react-bootstrap';
import { HeroHeader } from './ui/HeroHeader';
import { TrustedSection } from './ui/TrustedSection';
import { CardsStats } from './ui/CardsStats';
import { BrandWings } from './ui/BrandWings';
import { BannerSection } from './ui/BannerSection';
import { MasterLinkedIn } from './ui/MasterLinkedIn';
import { Testimonials } from './ui/Testimonials';
import { PricingSection } from './ui/PricingSection';
import { CommunitySection } from './ui/CommunitySection';
import { Footer } from './ui/Footer';
import HeroTrustedBackground from './assets/backgroundeffectheroandtrustfinal.webp';

export const Homepage = () => {
  return (
    <Container fluid className="p-0" style={{ minHeight: '100vh', backgroundColor: '#000' }}>
      <section
        className="hero-trusted-wrapper"
        style={
          {
            '--hero-trusted-bg': `url(${HeroTrustedBackground})`,
          } as React.CSSProperties
        }
      >
        <div className="hero-trusted-background" aria-hidden="true" />
        <HeroHeader />
        <TrustedSection />
      </section>
      <CardsStats />
      <BrandWings />
      <BannerSection />
      <MasterLinkedIn />
      <Testimonials />
      <PricingSection />
      <CommunitySection />
      <Footer />
    </Container>
  );
};
